import { Controller } from "@hotwired/stimulus"

// The conversation. Opens at the "new since your last visit" line when there
// is one, at the newest message otherwise. When a message lands while the
// tester is reading at the bottom, the page follows it down; when they have
// scrolled up to read, it leaves them where they are.
//
// While a post waits for the engine, the page also checks again by itself
// every two seconds, until nothing is pending. The engine says a post within
// a second or two and asks the page to refresh, but Turbo drops a refresh
// that arrives while the page is still loading, which it usually is right
// after the post. Without this, the post sat unsaid on screen until the next
// message arrived. Frans, 1 October.
//
// And when the page comes back into view, it asks for the conversation again.
// A phone closes the live connection when the screen locks or the app goes to
// the background, and a message that lands meanwhile is never sent again. On
// 9 October two messages in circle 3 reached the laptop and not the iPhone,
// whose connection only came back after them. Morphing keeps a half-typed post.
export default class extends Controller {
  static values = { pending: Number }
  static RECHECK_MS = 2000

  connect() {
    this.before = () => { this.atBottom = this.nearBottom() }
    this.after = () => { if (this.atBottom) this.toBottom(); this.recheck() }
    document.addEventListener("turbo:before-render", this.before)
    document.addEventListener("turbo:render", this.after)
    document.addEventListener("turbo:morph", this.after)
    this.back = (e) => {
      if (e.type === "visibilitychange" ? document.visibilityState === "visible" : e.persisted) {
        window.Turbo.session.refresh(location.href)
      }
    }
    document.addEventListener("visibilitychange", this.back)
    window.addEventListener("pageshow", this.back)

    const line = document.getElementById("new")
    line ? line.scrollIntoView({ block: "center" }) : this.toBottom()
    this.recheck()
  }

  disconnect() {
    clearTimeout(this.timer)
    document.removeEventListener("turbo:before-render", this.before)
    document.removeEventListener("turbo:render", this.after)
    document.removeEventListener("turbo:morph", this.after)
    document.removeEventListener("visibilitychange", this.back)
    window.removeEventListener("pageshow", this.back)
  }

  recheck() {
    clearTimeout(this.timer)
    if (this.pendingValue > 0) {
      this.timer = setTimeout(() => window.Turbo.session.refresh(location.href), this.constructor.RECHECK_MS)
    }
  }

  nearBottom() {
    return window.innerHeight + window.scrollY >= document.body.scrollHeight - 200
  }

  toBottom() {
    window.scrollTo(0, document.body.scrollHeight)
  }
}
